/**
 * Returns true if any form of authentication required.
 * Api exposed to public
 */
export default function isAuthenticationRequired(maskedCard) {
    try {
        const { pendingEvents = [] } = maskedCard.digitalCardData;
        return (maskedCard.digitalCardStatus === 'PENDING' &&
            [...pendingEvents].includes('PENDING_SCA'));
    }
    catch (error) {
        return false;
    }
}
//# sourceMappingURL=isAuthenticationRequired.js.map